import React, { useState, useEffect } from "react";

import { NavLink, useNavigate } from "react-router-dom";
import NotificationIcon from "./NotificationIcon";

import TopbarMobile from "./TopbarMobile";

export default function Navigation(props) {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    navigate("../login");
  };

  return (
    <>
      <TopbarMobile {...props} />
      <nav id="navigation">
        <ul>
          {/* Mostrar los primeros 3 ítems solo si no es "paciente" y `userRole` está definido */}
          {Array.isArray(props.userRole) && props.userRole.some((role) => role !== "paciente") && (
            <>
              <li>
                <NavLink to={`../pacientes`}>Pacientes</NavLink>
              </li>
              <li>
                <NavLink to={`../calendario`}>Calendario</NavLink>
              </li>
              {props.userRole.includes("administrador") && (
                <li>
                  <NavLink to={`../configuracion`}>Configuración</NavLink>
                </li>
              )}
            </>
          )}
          <li className="bell-active">
            <NotificationIcon {...props} />
          </li>
          <li>
            <a href="#!" onClick={handleLogout}>
              Cerrar Sesión
            </a>
          </li>
        </ul>
      </nav>
      <nav id="navigation-mobile">
        <ul>
          <li>
            <a href="#!" onClick={handleLogout}>
              Cerrar Sesión
            </a>
          </li>
          {Array.isArray(props.userRole) && props.userRole.some((role) => role !== "paciente") && (
            <>
              <li>
                <NavLink to={`../pacientes`}>Pacientes</NavLink>
              </li>
              <li>
                <NavLink to={`../calendario`}>Calendario</NavLink>
              </li>
              {props.userRole.includes("administrador") && (
                <li>
                  <NavLink to={`../configuracion`}>Configuración</NavLink>
                </li>
              )}
            </>
          )}
        </ul>
      </nav>
    </>
  );
}